// @lib-generic-ui
import React from "react";
import EditDocumentForm from "components/react-lib/generic-ui/firestore/EditDocumentForm";
import ReduxModal from "components/react-lib/generic-ui/modals/ReduxModal";
import { Stack } from "@mui/material";
import { useDispatch } from "react-redux";
import { modalsActions } from "store/react-lib/generic-ui/modals";

export default function EditDocumentModal({
  name,
  title,
  documentRef,
  fieldsToEdit,
  isCreate,
  createExtraData,
  saveCallback = (doc) => {},
  errorCallback,
  fieldConfig={},
}) {
  const dispatch = useDispatch();

  return (
    <ReduxModal name={name} title={title} fullWidth maxWidth="sm">
      <Stack pt={1}>
        <EditDocumentForm
          documentRef={documentRef}
          saveCallback={(data) => {
            if (saveCallback) {
              saveCallback(data);
            }
            dispatch(modalsActions.closeModal(name));
          }}
          errorCallback={errorCallback}
          fieldsToEdit={fieldsToEdit}
          isCreate={isCreate}
          createExtraData={createExtraData}
          fieldConfig={fieldConfig}
        />
      </Stack>
    </ReduxModal>
  );
}
